export default __webpack_public_path__ + "static/media/clientImg2.e32bb718.png";